import { ReactNode, useMemo } from 'react';

import { useAdobePageTracking } from 'library/hooks/useAdobeTracking';
import { AdobeTrackingContext } from 'main/adobeTracking/AdobeTrackingContext';
import AdobeTrackingPlugin from 'main/adobeTracking/AdobeTrackingPlugin';
import { logError } from 'main/adobeTracking/utils';

interface AdobeTrackingProviderProps {
	children: ReactNode;
	plugin?: AdobeTrackingPlugin;
}

export const AdobeTrackingProvider = ({
	children,
	plugin,
}: AdobeTrackingProviderProps): ReactNode => {
	const trackingPlugin = useMemo(
		() => plugin ?? new AdobeTrackingPlugin(),
		[plugin]
	);

	if (trackingPlugin.error) {
		logError('Failed to load Adobe Tracking script', trackingPlugin.error);
	}

	return (
		<AdobeTrackingContext.Provider value={trackingPlugin}>
			<AdobeTrackingPageTracker />
			{children}
		</AdobeTrackingContext.Provider>
	);
};

/**
 * Internal component to handle page tracking within the provider context.
 */
const AdobeTrackingPageTracker = (): null => {
	useAdobePageTracking();
	return null;
};

export default AdobeTrackingProvider;
